import script from "./assessment.vue?vue&type=script&setup=true&lang=js"
export * from "./assessment.vue?vue&type=script&setup=true&lang=js"

import "./assessment.vue?vue&type=style&index=0&id=0cf66c5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cf66c5c"]])

export default __exports__